import { Navigate } from 'react-router-dom'
import { routeNames } from 'src/modules/core/constants/routeNames'

export function CanceledSubscription() {
  return <Navigate to={routeNames.subscriptionPlans.path} replace />
}
